import { gql } from '@apollo/client';

export const createQuoteMutation = gql`
  mutation createQuoteReply($parentArticleId: ID!, $quote: JSON!) {
    createArticle(
      data: {
        body: $quote
        type: QUOTE
        status: "published"
        shouldStoreOnArweave: false
        parentArticle: { connect: { id: $parentArticleId } }
      }
    ) {
      id
    }
  }
`;
